module.exports = __webpack_public_path__ + "static/fipcbluepanda3-df06125349267e75effd9c20163bfcc8.jpeg";